export default {"src":"https://images-cdn.curipod.com/d-8835f655/_next/static/media/curiLogo.0c0d49a5.svg","height":298,"width":299};